import * as actions from './inventorySeparation/actions'
import * as mutations from './inventorySeparation/mutations'
import * as getters from './inventorySeparation/getters'

import { dataProps } from './inventorySeparation/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
        search_term_array: []
    },
    request_list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventorySeparation.js